import { CheckItemRecord } from "./CheckItemRecord";
import { CheckRecord } from "./CheckRecord";
import { DeleteRecord } from "./DeleteRecord";
import { DepositRecord } from "./DepositRecord";
import { DiscountRecord } from "./DiscountRecord";
import { EmployeeJob } from "./EmployeeJob";
import { EmployeeSalesTotal } from "./EmployeeSalesTotal";
import { GiftCardRecord } from "./GiftCardRecord";
import { LaborScheduleEntry } from "./LaborScheduleEntry";
import { ManualTipShare } from "./ManualTipShares";
import { PaidinRecord } from "./PaidinRecord";
import { PaidoutRecord } from "./PaidoutRecord";
import { PaymentRecord } from "./PaymentRecord";
import { Store } from "./Store";
import { StoreCheckRecord } from "./StoreCheckRecord";
import { TimeCard } from "./TimeCard";
import { TimeCardAuditRecord } from "./TimeCardAuditRecord";
import { TimecardHistory } from "./TimecardHistory";

export class EmployeeRecord {
	venueKey: number;
	ID: number;

	FirstName: string;
	LastName: string;
	NickName: string;
	ID1: string;
	ID2: string;
	Address: string;
	City: string;
	State: string;
	ZipCode: string;
	Phone1: string;
	Email: string;
	BirthDate: string;
	HireDate: string;
	LastRaiseDate: string;
	EmergencyPhone: string;
	EmergencyContact: string;
	W4Allowances: string;
	W4Status: string;
	AccessCode: number;
	Picture: string;
	Language: number;
	FoodHandlerCertDate: string;
	BartenderCardDate: string;
	RequireCard: boolean;
	EnforceScheduling: boolean;
	ExtendRights: boolean;
	ClockInOutOnly: boolean;
	FingerprintAtClockIn: boolean;
	FingerprintRequired: boolean;
	IsDeleted: boolean;
	IsTerminated: boolean;
	IsInactive: boolean;
	IsActive: boolean;
	Status: string;

	TerminationDate: string;
	TerminationID: number;

	Deleted: string;
	JobID1: number;
	JobRate1: number;
	JobPosition1: number;
	JobID2: number;
	JobRate2: number;
	JobPosition2: number;
	JobID3: number;
	JobRate3: number;
	JobPosition3: number;
	JobID4: number;
	JobRate4: number;
	JobPosition4: number;
	JobID5: number;
	JobRate5: number;
	JobPosition5: number;
	JobID6: number;
	JobRate6: number;
	JobPosition6: number;

	EmployeeJob: EmployeeJob[];

	TimeCards: TimeCard[];

	TimeCardAuditRecords: TimeCardAuditRecord[];

	ApprovedTimeCardAudits: TimeCardAuditRecord[];

	ApprovedDiscounts: DiscountRecord[];

	GiftCardRecords: GiftCardRecord[];

	VoidedPayments: PaymentRecord[];

	PaymentRecords: PaymentRecord[];

	CheckItems: CheckItemRecord[];

	VoidedCheckItems: CheckItemRecord[];

	CheckOwner: CheckRecord[];

	ChecksOpened: CheckRecord[];

	ChecksClosed: CheckRecord[];

	EmployeeSalesTotal: EmployeeSalesTotal[];

	OwnedPaidoutRecords: PaidoutRecord[];

	ApprovedPaidoutRecords: PaidoutRecord[];

	OwnedPaidinRecords: PaidinRecord[];

	DeleteCheckItemRecord: DeleteRecord[];

	ApprovedDeleteCheckItemRecord: DeleteRecord[];

	PayerManualTipShare: ManualTipShare[];

	ReceiverManualTipShare: ManualTipShare[];

	OwnerDepositRecord: DepositRecord[];

	ApproverDepositRecord: DepositRecord[];

	StoreCheckRecordOwner: StoreCheckRecord[];

	StoreCheckRecordOpener: StoreCheckRecord[];

	TimecardHistory: TimecardHistory[];

	LaborScheduleEntry: LaborScheduleEntry[];

	stores: Store;

	lastNameFirstName: string;

	public constructor(init?: Partial<EmployeeRecord>) {
		Object.assign(this, init);
		this.lastNameFirstName = `${this.LastName}, ${this.FirstName}`;
	}
}
